var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { ModalComponentAFY, FormBeneficiaryAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var ModalInsurance = function (props) {
    var openModal = props.openModal, setOpenModal = props.setOpenModal, isMaskedDocument = props.isMaskedDocument, dataFormInsurance = props.dataFormInsurance, titleInsured = props.titleInsured, insuredType = props.insuredType, listIdentificationType = props.listIdentificationType, handleSubmitInsured = props.handleSubmitInsured, searchInsurancePerson = props.searchInsurancePerson, t = props.t;
    var _a = useState(false), isChild = _a[0], setIsChild = _a[1];
    var handleChangeSelect = function (event) {
        var _a;
        var selectedId = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        // Find selected type by id within insuredType list (assumed array of { id, name | label })
        var list = Array.isArray(insuredType) ? insuredType : [];
        var match = list.find(function (item) { return "".concat(item === null || item === void 0 ? void 0 : item.id) === "".concat(selectedId); });
        var typeName = ((match === null || match === void 0 ? void 0 : match.name) || "").toString();
        var child = typeName.toLowerCase().includes("hij");
        console.log("TYPE NAME:", typeName, " IS CHILD:", child);
        setIsChild(child);
    };
    return (_jsx(ModalComponentAFY, __assign({ openModal: openModal, backgroundColor: "#ffffff", onClose: function () { return setOpenModal(false); }, border: 0, modalWidth: 986, padding: 40, modalHeight: "90%" }, { children: _jsx(FormBeneficiaryAFY, { isChild: isChild, isntMaskedDocument: isMaskedDocument, dataForm: dataFormInsurance, onClickAcquire: function noRefCheck() { }, onClickCancel: function () { return setOpenModal(false); }, onClickSave: function noRefCheck() { }, onNext: handleSubmitInsured, openModal: true, subtitle: t("confirmationData.subtitleBeneficiary"), title: titleInsured, typeInsuredOption: insuredType, TypeList: listIdentificationType, formsCompleted: [true, false, false], onChangeSelect: handleChangeSelect, onBlurDocument: function (event) {
                searchInsurancePerson(event);
            }, onBlurInput: function (event) {
                searchInsurancePerson(event);
            } }) })));
};
